import { Rank } from '../../state/ArenaTypes';

/**
 * Uptown Card Power: Big Joker (16) > Little Joker (15) > A (14) > K (13) > Q (12) > J (11) > 10..2
 */
export const UPTOWN_POWER: Record<string, number> = {
  '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9, '10': 10,
  'J': 11, 'Q': 12, 'K': 13, 'A': 14, 'LJ': 15, 'BJ': 16
};

/**
 * Downtown Card Power: Big Joker (16) > Little Joker (15) > A (14) > 2 (13) > 3 (12) > 4 (11) > 5 (10) > 6 (9) > 7 (8) > 8 (7) > 9 (6) > 10 (5) > J (4) > Q (3) > K (2)
 */
export const DOWNTOWN_POWER: Record<string, number> = {
  'K': 2, 'Q': 3, 'J': 4, '10': 5, '9': 6, '8': 7, '7': 8, '6': 9, '5': 10,
  '4': 11, '3': 12, '2': 13, 'A': 14, 'LJ': 15, 'BJ': 16
};

export const UPTOWN_RANK_VALUE: Record<Rank, number> = UPTOWN_POWER as Record<Rank, number>;
export const DOWNTOWN_RANK_VALUE: Record<Rank, number> = DOWNTOWN_POWER as Record<Rank, number>;
